
import { Container, Typography } from "@mui/material";
import { useEffect} from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";

interface Props {
  token: string;
  kayttajaId: number;
}

const Asetukset: React.FC<Props> = (props: Props): React.ReactElement => {



  const navigate: NavigateFunction = useNavigate();

  useEffect(() => {
    if (!props.token) {

      navigate("/login");


    }

  }, []);





  return (
    <Container>
      <Typography variant="h5" padding={2}>
        Asetukset
      </Typography>

      <Typography variant="body2">
        Täällä ei ole vielä mitään...

      </Typography>






    </Container>


  );

};


export default Asetukset;